import { render, staticRenderFns } from "./BodySalesAnalysis.vue?vue&type=template&id=770eca6a&scoped=true"
import script from "./BodySalesAnalysis.vue?vue&type=script&lang=js"
export * from "./BodySalesAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodySalesAnalysis.vue?vue&type=style&index=0&id=770eca6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770eca6a",
  null
  
)

export default component.exports